// =========================================================
// * Vue Material Dashboard PRO - v1.4.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

// import dotenv from "dotenv";

// dotenv.config();

console.log(process.env);

console.log("Environment variables loaded:", process.env.VUE_APP_APP_URL);

import Vue from "vue";
import axios from "axios";

// Dev tunnel services (ngrok, localtunnel, Cloudflare Tunnel...) hand out
// random subdomain.host.tld addresses for local testing — same shape as a
// real subdomain.company.com tenant URL, so without this list every one of
// them gets misread as a tenant name (e.g. "teaching-elf-skilled" from
// teaching-elf-skilled.ngrok-free.app), silently breaking every tenant-scoped
// request (login, profile fetch...) for whoever is testing through a tunnel.
const DEV_TUNNEL_SUFFIXES = [
  ".ngrok-free.app",
  ".ngrok.app",
  ".ngrok.io",
  ".loca.lt",
  ".trycloudflare.com",
];

// Extract tenantId from subdomain
const getTenantId = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");

  // For plain localhost or IP addresses, return null
  if (hostname === "localhost" || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    return null;
  }

  if (DEV_TUNNEL_SUFFIXES.some((suffix) => hostname.endsWith(suffix))) {
    return null;
  }

  // Handle subdomain.localhost (e.g., momen.localhost)
  if (parts.length === 2 && parts[1] === "localhost") {
    return parts[0];
  }

  // Handle subdomain.domain.com (e.g., tenant.example.com)
  if (parts.length > 2) {
    return parts[0];
  }

  return null;
};

// Global axios interceptor - applies to ALL axios requests in the app
axios.interceptors.request.use(
  (config) => {
    // Add tenantId header
    if (getTenantId() !== "demo-ns-hr" && getTenantId() !== null) {
      // Add tenantId header
      config.headers["tenantId"] = getTenantId();
    }

    // Add Authorization header if token exists
    const T = localStorage.getItem("Nannotoken");
    if (T) {
      const token = atob(T);
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";

import "./assets/v-select.scss";
import VCalendar from "v-calendar";
Vue.use(VCalendar);
// Introduced in vue file
import FunctionalCalendar from "vue-functional-calendar";
Vue.use(FunctionalCalendar, {
  dayNames: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
});

import MonthPicker from "vue-month-picker";
import MonthPickerInput from "vue-month-picker";

import VueMonthlyPicker from "vue-monthly-picker";
Vue.component("vue-monthly-picker", VueMonthlyPicker);

Vue.use(MonthPicker);
Vue.use(MonthPickerInput);
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);
import "vue-search-select/dist/VueSearchSelect.css";
import VueRouter from "vue-router";
import DashboardPlugin from "./material-dashboard";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/NanoSoft.css";
Vue.use(ElementUI);
// Plugins
import App from "./App.vue";
import Chartist from "chartist";

// Main JS (in UMD format)
import VueTimepicker from "vue2-timepicker";
Vue.component("VueTimepicker", VueTimepicker);
// CSS
import "vue2-timepicker/dist/VueTimepicker.css";

import FormTime from "@/components/FormTime.vue";
Vue.component("form-time", FormTime);

//// icon
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";

import ClearButton from "@/components/ClearButton.vue";

Vue.component("ClearButton", ClearButton);

// router setup
import routes from "./routes/routes";
// import VueExcelXlsx from "vue-excel-xlsx";
// // import Vue from "vue";

// Vue.use(VueExcelXlsx);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);

const moment = require("moment");
// require("moment/locale/es");

Vue.use(require("vue-moment"), {
  moment,
});

// configure router
// Use hash mode for Electron (file:// protocol), history mode for web
const isElectron = window.location.protocol === "file:";

const router = new VueRouter({
  mode: isElectron ? "hash" : "history",
  routes, // short for routes: routes
  // scrollBehavior: to => {
  //   if (to.hash) {
  //     return { selector: to.hash };
  //   } else {
  //     return { x: 0, y: 0 };
  //   }
  // },
  linkExactActiveClass: "nav-item active",
});

// console.warn("isElectron", isElectron);

const checkIfTokenIsValidAndExist = async () => {
  let T = localStorage.getItem("Nannotoken");
  if (!T) {
    return false;
  }

  let token = atob(T);
  const isValid = await store.dispatch("global/isTokenValid", token);

  return isValid;
};

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || "HR-CP";
  const isAuth = await checkIfTokenIsValidAndExist();
  // if (!isAuth) {
  //   return next({ name: "Login" });
  // }
  if (to.matched.some((record) => record.meta.IsAuth) === true) {
    if (
      localStorage.getItem("Nannotoken") === null ||
      localStorage.getItem("Nannotoken") === ""
    ) {
      return next({ name: "Login" });
    } else {
      return next();
    }
  } else {
    if (isAuth) {
      return next({ path: "/pages/employees" });
    }
    return next();
  }
});

import store from "./store"; // Import the store

import api from "./services/api";

// Make Axios available globally
Vue.prototype.$axios = api;

// global library setup
Vue.prototype.$Chartist = Chartist;
/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
  store,
});
